// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes runningAnimation {
  100% {
    transform: rotate(360deg);
  }
}
.bolt-status {
  fill: currentColor;
}
.bolt-status.success {
  color: rgba(85, 163, 98, 1);
  color: var(--component-status-success,rgba(85, 163, 98, 1));
}
@media (forced-colors: active) {
  .bolt-status.success {
    fill: rgba(85, 163, 98, 1);
    fill: var(--component-status-success,rgba(85, 163, 98, 1));
  }
}
.bolt-status.failed {
  color: rgba(205, 74, 69, 1);
  color: var(--component-status-error,rgba(205, 74, 69, 1));
}
@media (forced-colors: active) {
  .bolt-status.failed {
    fill: rgba(205, 74, 69, 1);
    fill: var(--component-status-error,rgba(205, 74, 69, 1));
  }
}
.bolt-status.warning {
  color: rgba(214, 127, 60, 1);
  color: var(--component-status-warning,rgba(214, 127, 60, 1));
}
@media (forced-colors: active) {
  .bolt-status.warning {
    fill: rgba(214, 127, 60, 1);
    fill: var(--component-status-warning,rgba(214, 127, 60, 1));
  }
}
.bolt-status.active {
  color: rgba(0, 120, 212, 1);
  color: var(--component-status-info,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-status.active {
    fill: rgba(0, 120, 212, 1);
    fill: var(--component-status-info,rgba(0, 120, 212, 1));
  }
}
.bolt-status.neutral {
  color: rgba(102, 102, 102, 1);
  color: var(--component-status-neutral,rgba(102, 102, 102, 1));
}
@media (forced-colors: active) {
  .bolt-status.neutral {
    fill: rgba(102, 102, 102, 1);
    fill: var(--component-status-neutral,rgba(102, 102, 102, 1));
  }
}
.bolt-status.animate {
  animation: runningAnimation 8s infinite linear;
}
.bolt-status.small-animate {
  animation: runningAnimation 4s infinite linear;
}
.bolt-status.rotate {
  transform: rotate(180deg);
}

.bolt-status-text {
  padding-right: 12px;
  padding-top: 3px;
  padding-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bolt-status-text.xl {
  padding-right: 16px;
  padding-top: 5px;
  padding-bottom: 7px;
}

.bolt-status-text-extra-padding {
  padding-left: 8px;
}

.bolt-status-extended {
  color: rgba( 255, 255, 255 ,  1 );
  color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  height: 24px;
  border-radius: 15px;
}
.bolt-status-extended.xl {
  border-radius: 48px;
  height: 32px;
}
.bolt-status-extended.success {
  background-color: rgba(85, 163, 98, 1);
  background-color: var(--component-status-success,rgba(85, 163, 98, 1));
}
.bolt-status-extended.failed {
  background-color: rgba(205, 74, 69, 1);
  background-color: var(--component-status-error,rgba(205, 74, 69, 1));
}
.bolt-status-extended.warning {
  background-color: rgba(214, 127, 60, 1);
  background-color: var(--component-status-warning,rgba(214, 127, 60, 1));
}
.bolt-status-extended.active {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--component-status-info,rgba(0, 120, 212, 1));
}
.bolt-status-extended.neutral {
  background-color: rgba(102, 102, 102, 1);
  background-color: var(--component-status-neutral,rgba(102, 102, 102, 1));
}

/*# sourceMappingURL=Status.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Status/Status.scss","webpack://./../azure-devops-ui/bin/Components/Status/Status.css","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAOA;EACI;IACI,yBAAA;ECNN;AACF;ADiBA;EACI,kBAAA;ACfJ;ADiBI;EAVA,2BAbuB;ECSzB,2DAA2D;ACqCzD;ADnCJ;EACE;IACE,0BAA0B;IAC1B,0DAA0D;EDa1D;ACXJ;AACA;EC6BI,2BAAA;EFnBA,yDAAA;ACPJ;AACA;EACE;IDSE,0BAAA;IAlBA,wDAXuB;ECuBzB;ACqBE;ADnBJ;EACE,4BD1ByB;EC2BzB,4DAA4D;AAC9D;ADKI;EAtBA;ICoBA,2BAA2B;ICa3B,2DAAA;EFXA;ACCJ;AACA;EACE,2BAA2B;EDCzB,wDAAA;ACCJ;AACA;ECKI;IFPA,0BAAA;IAvBI,uDAZmB;ECyCzB;AACF;ADHI;EACI,6BAAA;ECKN,6DAA6D;ADF3D;ACIJ;EACE;IDDE,4BAAA;IACI,4DAAA;ECGN;AACF;ADAA;EACI,8CG+PS;AF7Pb;AACA;EDAI,8CAAA;ACEJ;AACA;EACE,yBAAyB;ADAvB;;ACGJ;EDAQ,mBAAA;ECEN,gBAAgB;EAChB,mBAAmB;EDCrB,mBAAA;EACI,gBG4OQ;EF3OV,uBAAuB;AACzB;ADCA;EACI,mBGoBI;EHnBJ,gBAAA;EACA,mBAAA;ACCJ;;AAEA;EDCQ,iBAAA;ACCR;;AAEA;EACE,iCAAiC;EDG/B,0DAAA;EACI,YAAA;ECDN,mBAAmB;ADIjB;ACFJ;EACE,mBAAmB;EDKjB,YAAA;ACHJ;AACA;EDMI,sCAAA;EACI,sEAlGmB;AC8F3B;AACA;EACE,sCAAsC;EACtC,oEAAoE;AACtE;AACA;EACE,uCAAuC;EACvC,uEAAuE;AACzE;AACA;EACE,sCAAsC;EACtC,mEAAmE;AACrE;AACA;EACE,wCAAwC;EACxC,wEAAwE;AAC1E;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
